<h1 mat-dialog-title class="pt-2 text-center">Importer des documents</h1>
<div mat-dialog-content class="p-3">

    <div class="row">
        <div class="m-3 d-flex align-items-center justify-content-center col uploadfilecontainer"
             (click)="fileInput4DnD.click()" appDragDrop (onFileDropped)="onFileFromDragNDrop($event)">
            <input type="file" #fileInput4DnD (change)="onFileFromDragNDrop($event.target)" multiple>
            <mat-icon class="material-symbols-outlined mr-1" aria-label="add-image">upload_file</mat-icon> Déposer ou choisir un fichier
        </div>
    </div>

    <div class="row mt-2">
        <mat-chip-list class="col">
            @for (f of Files; track f) {
            <mat-chip selectable (removed)="remove(f)">
                {{f.name}}
                @if (true) {
                <mat-icon matChipRemove>cancel</mat-icon>
                }
            </mat-chip>
            }
        </mat-chip-list>
    </div>

    <div class="row d-flex justify-content-end">
        <button class="col" color="primary" mat-raised-button (click)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col" color="primary" mat-raised-button
                (throttledClick)="addDocument()" title="SaveDocument">
            Ajouter
        </button>
    </div>
</div>